import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  constructor() { }
  public exportAsExcelFile(json: any[], excelFileName: string): void {  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json); 
     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };  
     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }); 
      this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  public exportAsExcelFileWithHeaders(json: any[], excelFileName: string, headers: string[]): void {
    // Build AOA so only the provided headers appear (json_to_sheet appends extra object keys).
    const rows = [headers].concat(
      (json || []).map((row) => headers.map((header) => {
        const value = row ? row[header] : '';
        return value === undefined || value === null ? '' : value;
      }))
    );
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(rows);
    worksheet['!cols'] = headers.map((header) => {
      if (header === 'Feedback_History' || header.indexOf('_Remark') > -1) {
        return { wch: 60 };
      }
      return { wch: Math.min(Math.max(header.length + 2, 16), 28) };
    });
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});   FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
  }
  }
